<template>
  <a-row class="not-resize-for-mobile">
    <a-col :sm="24" :md="24" :lg="18" :xl="14" :xxl="10">
      <a-card :bordered="false">
        <!-- 検索区域 -->
        <!--<div class="table-page-search-wrapper">
          <a-form-model layout="inline" @keyup.enter.native="searchQuery(false, false)">
            <a-row :gutter="24">
              <a-col :sm="24" :md="12" :lg="12" :xl="12" :xxl="12">
                <a-form-model-item label="关键字">
                  <a-input
                    :placeholder="$t('disp.ph.matchOr', [$t('disp.postCode'), $t('disp.postName')])"
                    v-model="queryParam.code"
                  ></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :sm="24" :md="12" :lg="12" :xl="12" :xxl="12">
                <a-form-model-item :wrapperCol="{ span: 24 }" class="width-fit-content">
                  <a-button type="primary" @click="searchQuery(false, false)" icon="search">{{
                    $t('disp.btn.search')
                  }}</a-button>
                  <a-button @click="searchReset" icon="stop">{{ $t('disp.btn.reset') }}</a-button>
                </a-form-model-item>
              </a-col>
            </a-row>
          </a-form-model>
        </div>-->

        <!-- ボタン操作区域 -->
        <div class="table-operator">
          <a-button @click="handleAdd" type="primary" icon="plus">{{ $t('disp.btn.add') }}</a-button>
          <a-button
            v-if="selectedRowKeys.length > 0"
            @click="batchDel"
            icon="close"
            :title="this.$t('msg.confirm.deleteBatch')"
            >{{ this.$t('disp.btn.deleteBatch') }}</a-button
          >
        </div>

        <!-- table区域-begin -->
        <div>
          <!--<div class="ant-alert ant-alert-info div-selected-info">
            <i class="anticon anticon-info-circle ant-alert-icon"></i>
            {{ this.$t('disp.selected') }}
            <a class="a-selected-info">{{ selectedRowKeys.length }}</a>
            {{ this.$t('disp.item') }}
            <a @click="onClearSelected">{{ this.$t('disp.clear') }}</a>
          </div>-->

          <a-table
            ref="table"
            class="action"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            @change="handleTableChange"
          >
            <span slot="rowIndex" slot-scope="text, record, index">
              {{ (ipagination.current - 1) * ipagination.pageSize + parseInt(index) + 1 }}
            </span>
            <span slot="action" slot-scope="text, record">
              <a @click="handleEdit(record)">{{ $t('disp.btn.edit') }}</a>
              <a-divider type="vertical" />
              <a-popconfirm :title="$t('msg.confirm.delete')" @confirm="() => handleDelete(record.id)">
                <a>{{ $t('disp.btn.delete') }}</a>
              </a-popconfirm>
            </span>
          </a-table>
        </div>
        <!-- table区域-end -->

        <!-- フォーム区域 -->
        <position-modal ref="modalForm" @ok="modalFormOk"></position-modal>
      </a-card>
    </a-col>
  </a-row>
</template>

<script>
import { tableMixin } from '@/mixins/tableMixin'
import JDictSelectTag from '@/components/dict/JDictSelectTag'
import PositionModal from './modules/PositionModal'

export default {
  name: 'PositionManage',
  mixins: [tableMixin],
  components: {
    PositionModal,
    JDictSelectTag,
  },
  data() {
    return {
      description: '职位管理页面',
      // テーブルタイトル
      columns: [
        //{
        //  title: '#',
        //  dataIndex: '',
        //  key: 'rowIndex',
        //  width: 47,
        //  align: 'center',
        //  scopedSlots: { customRender: 'rowIndex' },
        //},
        {
          title: this.$t('disp.postCode'),
          align: 'left',
          dataIndex: 'code',
        },
        {
          title: this.$t('disp.postName'),
          align: 'left',
          dataIndex: 'name',
        },
        {
          title: this.$t('disp.postRank'),
          align: 'center',
          dataIndex: 'postRank',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/blaze-sys/k00/k0009/PositionManage/listByCodeAndName',
        delete: '/blaze-sys/k00/k0009/PositionManage/delete',
        deleteBatch: '/blaze-sys/k00/k0009/PositionManage/deleteBatch',
      },
    }
  },
  computed: {},
}
</script>
<style scoped></style>
